import { computed } from 'vue'
import { useRoute } from 'vue-router'

/**
 * Composable to determine if current route is a guest checkout route
 * Uses route path instead of store state for reliable detection
 */
export function useIsGuestCheckout() {
  const route = useRoute()

  const isGuestCheckout = computed(() => {
    return route.path.startsWith('/checkout/guest')
  })

  return {
    isGuestCheckout
  }
}

/**
 * Composable to determine if current route is an OPC checkout route
 * Uses route path instead of store state for reliable detection
 */
export function useIsOpcCheckout() {
  const route = useRoute()

  const isOpcCheckout = computed(() => {
    return route.path.includes('-opc-')
  })

  return {
    isOpcCheckout
  }
}
